import React from 'react';
import './card.scss';

type CardProps = {
  className?: string;
  stretchVertical?: boolean;
  titleImage?: {
    src: string;
    alt: string;
  };
  cardTitle?: string;
  cardSubText?: string;
  cardTitleClassName?: string;
  onClose?: () => void;
  children?: React.ReactNode;
};

export default function Card({
  className,
  stretchVertical,
  titleImage,
  cardTitle,
  cardSubText,
  cardTitleClassName,
  onClose,
  children,
}: CardProps) {
  return (
    <div className={`${className || ''} Card`} data-testid="Card">
      <div
        className={`card ${stretchVertical ? 'stretch-vertical' : ''}`}
        data-testid="card-container"
      >
        {titleImage ? (
          <div className="card-image">
            <figure className="image is-3by2">
              <img src={titleImage.src} alt={titleImage.alt} data-testid="title-image" />
            </figure>
            {cardTitle && (
              <div className="align-bottom has-padding-4">
                <h3
                  className="image-title title is-3 has-text-white has-text-weight-bold"
                  data-testid="card-title-with-image"
                >
                  {cardTitle}
                </h3>
                {cardSubText && (
                  <div
                    className="has-text-weight-bold has-text-white"
                    data-testid="card-title-with-subtext"
                  >
                    {cardSubText}
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          cardTitle && (
            <div
              className={`card-header card-header-title ${cardTitleClassName}`}
              data-testid="card-title"
            >
              <div>
                {cardTitle}
                {cardSubText && (
                  <div
                    className="has-text-grey has-text-small"
                    data-testid="card-title-with-subtext"
                  >
                    {cardSubText}
                  </div>
                )}
              </div>
              {onClose && (
                <span
                  automationid="General_Button_CloseCard"
                  onClick={onClose}
                  className="icon-cross is-icon-7"
                  data-testid="card-close"
                ></span>
              )}
            </div>
          )
        )}

        <div className="card-content">{children}</div>
      </div>
    </div>
  );
}
